module.exports = __webpack_public_path__ + "static/media/23116894_1638433842898467_7897368544849181529_o.3b0d4d98.jpg";